import {
  Box, Button,
  alpha,
  styled,
} from '@mui/material';
import { spaceCadet } from '../../../../../../../utils/colors';

const StyledBox = styled(Box)(() => ({
  padding: '12px 12px 10px 20px',
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',
  '& img': {
    height: 12,
    width: 'auto',
  },
  '& .MuiButton-root': {
    '& svg': {
      fontSize: 'inherit',
    },
  },
}));

export default StyledBox;

export const BackButton = styled(Button)({
  backgroundColor: 'transparent',
  padding: 0,
  fontSize: 24,
  minWidth: 0,
  color: spaceCadet[700],
  '&:hover': {
    backgroundColor: alpha(spaceCadet[300], 0.5),
  },
  '& svg': {
    color: 'inherit',
    fontSize: 'inherit',
  },
});
